import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {
    mapJsonToPrevCustElemApiResponse, mapJsonToPrevServElemApiResponse,
    mapJsonToPrevServElemDTOApiResponse,
    mapJsonToPrevServElemDTOSumApiResponse,
    mapJsonToServElemDTOApiResponse,
    mapPrevServElemToJson,
    PrevCustElem,
    PrevCustElemApiResponse,
    PrevServElem,
    PrevServElemApiResponse,
    PrevServElemDTOApiResponse,
    PrevServElemDTOSumApiResponse,
    ServElemDTOApiResponse
} from "./types";
import {columnFiltersParam, sortingParam} from "./Services";
import * as Yup from "yup";

const moment = require('moment')

export function useDeletePrevServElem() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) => {
    const response = await AxiosInstance.delete('prevservelem/'+id+'/');
     return  response
    },
     onSettled: () => queryClient.invalidateQueries({ queryKey: ['fetchServElem'] }), //refetch Preventivi after mutation, disabled for demo
  });
}


export  function useGetServElemDTOByPrev(pagination: MRT_PaginationState,columnFilters:  MRT_ColumnFiltersState,globalFilter: string,sorting: MRT_SortingState, idprevtesta: number) {
  return useQuery<ServElemDTOApiResponse>({
    queryKey: ['fetchServElemDTO',
       columnFilters, //refetch when columnFilters changes
       globalFilter, //refetch when globalFilter changes
       pagination.pageIndex, //refetch when pagination.pageIndex changes
       pagination.pageSize, //refetch when pagination.pageSize changes
       sorting, //refetch when sorting changes
       idprevtesta
    ],
    queryFn: async () => {

      const myOffset = (pagination.pageIndex==0) ? "0": `${pagination.pageSize*(pagination.pageIndex)}`;
      // const myURL = '?limit='+`${pagination.pageSize}`+'&offset='+myOffset+'&search='+(globalFilter ?? '')+columnFiltersParam(columnFilters)+'&ordering='+sortingParam(sorting);
      // const myURL = '?limit=1000'+'&offset='+myOffset+'&search='+(globalFilter ?? '')+columnFiltersParam(columnFilters)+'&ordering='+sortingParam(sorting);
      const myURL = `?limit=1000&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParam(columnFilters,'VPV01')}&ordering=${sortingParam(sorting,'VPV01')}`;


      const response = await AxiosInstance.get(`servelemdto/${myURL}&VPV01_IDPREVTESTA=${idprevtesta}`);

      return mapJsonToServElemDTOApiResponse(response.data)

    },
    refetchOnWindowFocus: false,
  });
}

export  function useGetServElemDTOByPrevFlgSE(pagination: MRT_PaginationState,columnFilters:  MRT_ColumnFiltersState,globalFilter: string,sorting: MRT_SortingState, idprevtesta: number) {
  return useQuery<ServElemDTOApiResponse>({
    queryKey: ['fetchServElemDTO',
       columnFilters, //refetch when columnFilters changes
       globalFilter, //refetch when globalFilter changes
       pagination.pageIndex, //refetch when pagination.pageIndex changes
       pagination.pageSize, //refetch when pagination.pageSize changes
       sorting, //refetch when sorting changes
       idprevtesta
    ],
    queryFn: async () => {

      const myOffset = (pagination.pageIndex==0) ? "0": `${pagination.pageSize*(pagination.pageIndex)}`;
      // const myURL = '?limit='+`${pagination.pageSize}`+'&offset='+myOffset+'&search='+(globalFilter ?? '')+columnFiltersParam(columnFilters)+'&ordering='+sortingParam(sorting);
      const myURL = '?limit=1000'+'&offset='+myOffset+'&search='+(globalFilter ?? '')+columnFiltersParam(columnFilters,'VPV01')+'&ordering='+sortingParam(sorting,'VPV01');

      const response = await AxiosInstance.get('servelemdtobyprevflgse/'+idprevtesta+'/'+myURL);

      return mapJsonToServElemDTOApiResponse(response.data)
    },
    refetchOnWindowFocus: false,
  });
}


export  function useGetPrevServElemDTOSumByPrev(pagination: MRT_PaginationState,columnFilters:  MRT_ColumnFiltersState,globalFilter: string,sorting: MRT_SortingState, idprevtesta: number) {
  return useQuery<PrevServElemDTOSumApiResponse>({
    queryKey: ['fetchPrevServElemDTOSum',
       columnFilters, //refetch when columnFilters changes
       globalFilter, //refetch when globalFilter changes
       pagination.pageIndex, //refetch when pagination.pageIndex changes
       pagination.pageSize, //refetch when pagination.pageSize changes
       sorting, //refetch when sorting changes
       idprevtesta
    ],
    queryFn: async () => {

      const myOffset = (pagination.pageIndex==0) ? "0": `${pagination.pageSize*(pagination.pageIndex)}`;
      // const myURL = '?limit='+`${pagination.pageSize}`+'&offset='+myOffset+'&search='+(globalFilter ?? '')+columnFiltersParam(columnFilters)+'&ordering='+sortingParam(sorting);
      const myURL = `?limit=1000&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParam(columnFilters,'VPV04')}&ordering=${sortingParam(sorting,'VPV04')}`;

      const response = await AxiosInstance.get('prevservelemdtosumbyprev/'+idprevtesta+'/'+myURL);
      return mapJsonToPrevServElemDTOSumApiResponse(response.data)

    },
    refetchOnWindowFocus: false,
  });
}


export function useCreatePrevServElem() {
  const queryClient = useQueryClient();
  return useMutation({

    mutationFn: async (prevSE: PrevServElem) => {
    // console.log("prevSE", prevSE)
      return AxiosInstance.post('prevservelem/0/',mapPrevServElemToJson(prevSE));
    },
   // onSuccess: () => queryClient.invalidateQueries({ queryKey: ['fetchServElemDTO'] }), //refetch Preventivi after mutation, disabled for demo
     });
}


export function useUpdatePrevServElem() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (prevservelem: PrevServElem) => {
         return AxiosInstance.patch('prevservelem/'+prevservelem.id+'/',mapPrevServElemToJson(prevservelem));
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['fetchPrevServElemDTOSum'] }), //refetch Preventivi after mutation, disabled for demo
  });
}


export function useGetPrevServElemById(id: number) {
  return useQuery<PrevServElemApiResponse>({
    queryKey: ['fetchGetPrevServElemById', id],
    enabled: id > 0, // 🔑 THIS IS CRITICAL
    queryFn: async () => {
      const response = await AxiosInstance.get(
        `prevservelem/?limit=1000&offset=0&PV04_ID=${id}`
      );

      const mapped = mapJsonToPrevServElemApiResponse(response.data);

      //console.log('PREVSERVELEM:', mapped);

      return mapped;
    },
    refetchOnWindowFocus: false,
  });
}

export function useGetPrevServElemDTOById(id: number) {
  return useQuery<PrevServElemDTOApiResponse>({
    queryKey: ['fetchGetPrevServElemDTOById', id],
    enabled: id > 0, // 🔑 THIS IS CRITICAL
    queryFn: async () => {
      const response = await AxiosInstance.get(
        `prevservelemdto/?limit=1000&offset=0&VPV04_ID__exact=${id}`
      );

      const mapped = mapJsonToPrevServElemDTOApiResponse(response.data);

      //console.log('PREVSERVELEMDTO:', mapped);

      return mapped;
    },
    refetchOnWindowFocus: false,
  });
}



export const validationSchemaPrevServElem: Yup.ObjectSchema<PrevServElem> = Yup.object({
  id: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),
  idprevtesta: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),
  idservelem: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),
  numprep: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),
  note: Yup.string().optional().nullable(),
  numanalisi: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),
  numconf: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),
  numform: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),
  numtot: Yup.number().required('Campo obbligatorio').typeError('Numero non valido'),

  // flgprevcons: Yup.mixed<'P' | 'C'>().oneOf(['P', 'C'], 'Valore non valido').required('Campo obbligatorio'),
});


